export default __webpack_public_path__ + "static/media/icon-tache.f87e2657.svg";